// extracted by mini-css-extract-plugin
export var askAiIcon = "_ps-9";
export var container = "_ps-0";
export var groupSeparator = "_ps-a";
export var highlight = "_ps-4";
export var resultIcon = "_ps-5";
export var resultItem = "_ps-7";
export var resultSubtitle = "_ps-3";
export var resultTitle = "_ps-2";
export var resultsList = "_ps-1";
export var searchGroup = "_ps-6";
export var selected = "_ps-8";